<script>
import { createHOC } from 'vue-hoc'
import { queryDictionaryDetails } from '@centit/api-admin/cp'
import { RadioGroup } from '@centit/ui-form'

const options = {
  name: 'DictionaryRadio',

  props: {
    code: {
      type: String,
      // required: true,
    },
  },
}

// const methods = {}

const renderWith = {
  props: {
    query() {
      if (!this.code) {
        return () => {
          return []
        }
      }

      // let fn = methods[this.code]
      //
      // if (fn) return fn
      //
      // fn = () => queryDictionaryDetails(this.code)
      // methods[this.code] = fn

      return () => queryDictionaryDetails(this.code)
    },
    valueField: 'dataCode',
    textField: 'dataValue',
  },
}

export default createHOC(RadioGroup, options, renderWith)
</script>
